export function pitchClassDistanceCents(targetMidi, detectedMidi) {
    if (!Number.isFinite(targetMidi) || !Number.isFinite(detectedMidi))
        throw new Error("INVALID_PITCH");
    const rawSemitones = Math.abs(targetMidi - detectedMidi) % 12;
    return Math.round(Math.min(rawSemitones, 12 - rawSemitones) * 100);
}
export function scorePitchAttempt(targetMidi, detectedMidi, clarity, scoring) {
    const centsError = pitchClassDistanceCents(targetMidi, detectedMidi);
    const normalizedClarity = Math.min(1, Math.max(0, clarity));
    if (normalizedClarity < scoring.clarityFloor || centsError >= scoring.toleranceCents) {
        return { band: "MISS", centsError, scoreDelta: 0 };
    }
    const accuracy = 1 - centsError / Math.max(1, scoring.toleranceCents);
    const clarityQuality = (normalizedClarity - scoring.clarityFloor) / Math.max(0.01, 1 - scoring.clarityFloor);
    const scoreDelta = Math.max(0, Math.round(scoring.maxPoints * accuracy * (0.8 + 0.2 * clarityQuality)));
    const band = centsError <= 25 ? "PERFECT" : centsError <= 70 ? "GREAT" : "CLOSE";
    return { band, centsError, scoreDelta };
}
//# sourceMappingURL=pitch-challenge-scoring.js.map